module.exports = __webpack_public_path__ + "img/red-heart.dc167f6a.svg";